const STORAGE_KEY = 'sellerclub_beta_dashboard_v4';
const TTL_MS = 25 * 60 * 1000;

function readStore() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeStore(obj) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch {
    /* quota */
  }
}

export function dashboardSessionKey(profileId, scope) {
  return `${String(profileId)}|${scope}`;
}

export function readDashboardSession(profileId, scope) {
  const entry = readStore()[dashboardSessionKey(profileId, scope)];
  if (!entry?.savedAt || !entry?.payload) return null;
  if (Date.now() - entry.savedAt > TTL_MS) return null;
  return entry.payload;
}

export function writeDashboardSession(profileId, scope, payload) {
  const store = readStore();
  store[dashboardSessionKey(profileId, scope)] = {
    savedAt: Date.now(),
    payload,
  };
  writeStore(store);
}

export function clearAllDashboardSessions() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function clearDashboardSessionsForProfile(profileId) {
  if (!profileId) return;
  const prefix = `${String(profileId)}|`;
  const store = readStore();
  let changed = false;
  for (const key of Object.keys(store)) {
    if (key.startsWith(prefix)) {
      delete store[key];
      changed = true;
    }
  }
  if (changed) writeStore(store);
}
